<template>
  <b-container fluid class="auth-loader">
    <b-row class="wrapper">
      <b-col class="column-wrapper" cols="12">
        <div>
          <h1 v-if="!isUs" class="logo">
            <img src="@/assets/images/logo_kurazushi.svg" alt="くら寿司" />
          </h1>
          <h1 v-if="isUs" class="logo">
            <img src="@/assets/images/welcome-us/logo.svg" />
          </h1>
          <dl class="text-top">
            <dt>{{ $t('common.certification') }}</dt>
            <dd>{{ $t('common.pleaseWait') }}</dd>
          </dl>
          <div class="image"><img src="@/assets/images/auth_loading.gif" alt="" /></div>
        </div>
        <div>
          <dl class="text-bottom">
            <dd>{{ $t('common.busyTimes') }}</dd>
            <dd>{{ $t('common.scanTheQRCodeAgain') }}</dd>
          </dl>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
export default {
  computed: {
    defaultLanguage() {
      return process.env.VUE_APP_LANG
    },
    isUs() {
      return this.defaultLanguage === 'us'
    },
  },
}
</script>
<style lang="scss" scoped>
.auth-loader {
  padding: 0;
  height: 100vh;
  max-height: 540px;
  min-height: 180px;
  display: flex;
  justify-content: center;
  font-size: 14px;
}
.wrapper {
  width: 100%;
}
.column-wrapper {
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: center;
}
.logo {
  padding-top: 40px;
  img {
    width: 120px;
  }
}
.text-top {
  margin-top: 60px;
  dt {
    font-size: 24px;
  }
  dd {
    margin-top: 16px;
  }
}
.text-bottom {
  white-space: pre-line;

  dd + dd {
    margin-top: 16px;
  }
}
.image {
  img {
    width: 110px;
    margin-top: 16px;
  }
}
</style>
